export type NewsletterSaveMode = 'create' | 'overwrite';

export const BLANK_NEWSLETTER_BODY = `<p>Hi {{customerName}},</p>
<p>Your newsletter content goes here.</p>

{{unsubscribeWidget}}`;

export function newsletterNameKey(name: string): string {
  return name.trim().toLowerCase();
}

export function newsletterSaveMode(id: string | null | undefined): NewsletterSaveMode {
  return id ? 'overwrite' : 'create';
}

export function nextCloneName(existingNames: string[], sourceName: string): string {
  const taken = new Set(existingNames.map(newsletterNameKey));
  const base = `${sourceName.trim() || 'Newsletter'} copy`;
  if (!taken.has(newsletterNameKey(base))) return base;
  let index = 2;
  while (taken.has(newsletterNameKey(`${base} ${index}`))) {
    index += 1;
  }
  return `${base} ${index}`;
}

export function withUnsubscribeWidget(body: string): string {
  if (body.includes('{{unsubscribeWidget}}')) return body;
  return `${body.trim()}\n\n{{unsubscribeWidget}}`;
}
